import { RequestBazowy } from './requestBazowy';

export class IdModel extends RequestBazowy {
    public id: string;
}
